import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { FlowDto } from '@/types/dtos/flows/response/flow.dto.ts';
import { GET_FLOW_QUERY_KEY } from '@/state/queries/flows/use-get-flow.ts';
import { GET_EVENT_FLOWS_QUERY_KEY } from '@/state/queries/flows/use-get-event-flows.ts';

export const useCreateScopedPlanMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ flowId, eventSlotId }: { flowId: string; eventSlotId: string }) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/flows/${flowId}/scopes/event-slot/${eventSlotId}`;
      return sendJSONRequest({ url, method: METHOD.POST, token: token ?? undefined }) as Promise<FlowDto>;
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: [GET_FLOW_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [GET_EVENT_FLOWS_QUERY_KEY] }),
      ]);
    },
  });
};

export const useArchiveScopedFlowsMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ flowId, eventSlotId }: { flowId: string; eventSlotId: string }) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/flows/${flowId}/scopes/event-slot/${eventSlotId}/archive`;
      return sendJSONRequest({ url, method: METHOD.POST, token: token ?? undefined });
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: [GET_FLOW_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [GET_EVENT_FLOWS_QUERY_KEY] }),
      ]);
    },
  });
};

export const useRestoreScopedFlowsMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ flowId, eventSlotId }: { flowId: string; eventSlotId: string }) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/flows/${flowId}/scopes/event-slot/${eventSlotId}/restore`;
      return sendJSONRequest({ url, method: METHOD.POST, token: token ?? undefined });
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: [GET_FLOW_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [GET_EVENT_FLOWS_QUERY_KEY] }),
      ]);
    },
  });
};
